// @flow

import React, { Component } from 'react';

import './CrossFadeImage.css';

type CrossFadeProps = {
  src: string,
};

type CrossFadeState = {
  prevSrc: string,
  currentSrc: string,
  currentLoaded: boolean,
};

class CrossFadeImage extends Component<CrossFadeProps, CrossFadeState> {
  handleLoad: () => void;

  constructor(props: CrossFadeProps) {
    super(props);

    this.state = {
      prevSrc: '',
      currentSrc: props.src,
      currentLoaded: false,
    };

    this.handleLoad = this.handleLoad.bind(this);
  }

  componentWillReceiveProps(nextProps: CrossFadeProps) {
    const { src: currentSrc } = this.props;
    const { src: nextSrc } = nextProps;

    if (currentSrc !== nextSrc) {
      this.setState({
        prevSrc: currentSrc,
        currentSrc: nextSrc,
        currentLoaded: false,
      });
    }
  }

  handleLoad() {
    this.setState({
      currentLoaded: true,
    });
  }

  render() {
    const { prevSrc, currentSrc, currentLoaded } = this.state;

    return (
      <div className="CrossFadeImage">
        <img
          className={`CrossFadeImage__img CrossFadeImage__img--top ${currentLoaded ? 'CrossFadeImage__img--top-loaded' : ''}`}
          alt=""
          src={`${currentSrc}?auto=webp`}
          key={currentSrc}
          onLoad={this.handleLoad}
        />

        <img
          className="CrossFadeImage__img CrossFadeImage__img--bottom"
          alt=""
          src={prevSrc}
        />
      </div>
    );
  }
}

export default CrossFadeImage;



// WEBPACK FOOTER //
// ./src/components/CrossFadeImage/index.js